<template>
  <div ref="inputDateRef" class="form-group mb-0 input-container" :id="id">
    <label v-if="label" :for="id">{{ label }}</label>
    <div
      class="d-flex align-items-center position-relative"
      :class="[
        'form-control control',
        'p-0',
        { 'text-muted': !displayValue },
        { 'control-disabled': disabled },
      ]"
      style="cursor: pointer; min-height: 40px"
      @click="triggerInput"
    >
      <div class="flex-grow-1 px-2 display-value" @click="triggerInput">
        {{ displayValue || placeholder }}
      </div>
      <span
        class="px-2"
        @click.stop="triggerInput"
        style="color: #6c757d; cursor: pointer"
      >
        <i class="fas fa-calendar-alt"></i>
      </span>
      <input
        ref="dateInput"
        :type="type"
        v-model="currentValue"
        @change="onInput"
        class="position-absolute"
        style="opacity: 0; width: 0; height: 0; top: 30px; left: 0"
        :name="name"
        :id="id"
      />
    </div>
    <small class="text-danger m-0" v-if="currentError">{{
      currentError
    }}</small>
  </div>
</template>

<script>
export default {
  name: "InputDate",
  props: {
    value: String,
    label: String,
    placeholder: String,
    error: String,
    name: String,
    id: String,
    type: { type: String, default: "date" },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      currentError: this.error,
      showPicker: false,
      currentValue: this.value,
    };
  },
  computed: {
    displayValue() {
      if (!this.currentValue) return "";
      // Format YYYY-MM-DD to DD/MM/YYYY
      const parts = this.currentValue.split("-");
      if (this.type === "month" && parts.length === 2) {
        const monthsID = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "Mei",
          "Jun",
          "Jul",
          "Agu",
          "Sep",
          "Okt",
          "Nov",
          "Des",
        ];
        return `${monthsID[parseInt(parts[1]) - 1]} ${parts[0]}`;
      }
      if (parts.length === 3) {
        return `${parts[2]}/${parts[1]}/${parts[0]}`;
      }
      return "";
    },
  },
  methods: {
    triggerInput() {
      if (this.disabled) return;
      this.$refs.dateInput.showPicker();
      this.showPicker = true;
    },
    onInput(event) {
      const value = event.target.value;
      this.currentValue = value;
      if (value) this.currentError = "";
      this.$emit("change", value);
    },
    handleClickOutside(event) {
      if (
        this.$refs.inputDateRef &&
        !this.$refs.inputDateRef.contains(event.target)
      ) {
        if (this.required && !this.currentValue && this.showPicker) {
          this.currentError = "This field is required";
        }
        this.showPicker = false;
      }
    },
  },
  watch: {
    error(value) {
      this.currentError = value;
    },
    value(value) {
      this.currentValue = value;
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.input-container {
  width: 100%;
}

.control {
  border-radius: 6px;
}

.control-disabled {
  background-color: #e9ecef;
  cursor: not-allowed;
}

label {
  color: #374151;
  font-weight: 600;
  font-size: 14px;
  margin: 0;
}

.display-value {
  font-size: 1rem;
}

.text-muted {
  font-size: 1rem;
  color: #2e364666 !important;
  opacity: 1 !important; /* Firefox */
}
</style>



// WEBPACK FOOTER //
// src/components/Input/InputDate.vue